export default "__VITE_ASSET__BuW6j9FS__"